<style scoped>
.loader {
position: absolute;
top :0;
left: 0;
right: 0;
bottom: 0;
margin: auto;
}
</style>

<template lang="pug">
  .main-content-padded
    .row
      .col
        .bcrumb
          a(href='/NewsletterSubsciber') Subscriber > {{listName}}
      .col.s12.m12
        table.striped
          thead
            tr
              th.table-header.sortable
                | Email
              th.table-header.sortable
                | Date Registered
          tbody
            //- tr
            tr(v-for='(subs, index) in subcriber.contacts')
              td {{subs.email}}
              td {{subs.modifiedAt | date}}
            div.preloader-wrapper.big.active.loader(v-if='!subcriber.contacts')
              div.spinner-layer.spinner-green-only
                div.circle-clipper.left
                  div.circle
                div.gap-patch
                  div.circle
                div.circle-clipper.right
                  div.circle


            //- p.title.medium.grey-text.center-align Nothing to Show

</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  meta: {
    title: 'Newsletter Subscribers'
  },
  data () {
    return {
      subcriber: [],
      contactList: []
    }
  },
  mounted () {
    this.getSubscibers()
  },
  filters: {
    date: function (val) {
      return moment(val).format('MMM DD, YYYY')
      // return moment(val).format('MMM DD, YYYY, h:mm:ss a')
    }
  },
  created() {
    this.listId = this.$route.params.listId
    this.listName = this.$route.params.listName
  },
  computed: {},
  methods: {
    getSubscibers () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-get-contact-groups-subs/${this.listId}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.subcriber = result.data
          })
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-newsletter-subscribers-list.vue